import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";
import CustomFieldItemsList from "../../common/form-items-list";

export default class ListCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        // organizationId: PropTypes.string.isRequired,
        customField: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.LIST_MULTI;

        this.initFormData.listItems = null;
        this.initFormData.listItemsIncSeed = 0;

        if (this.props.customField) {
            this.initFormData.listItems = _.get(this.props.customField.params,'listItems', null);
            this.initFormData.listItemsIncSeed = _.get(this.props.customField.params,'listItemsIncSeed', 0);
        }

        this.formStructure.fields.listItems = {
            type: 'select',
            isRequired: true,
            label: 'List Items',
            validator: (val) => {
                let res = true;
                if (!val || val.length < 1) return 'Add at least one item';
                val.map(i => {
                    if (i.value.trim() === '') res = 'Options items should not be empty';
                });
                return res;
            }
        };

        this.formStructure.fields.listItemsIncSeed = {
            type: 'input',
            isRequired: false
        };

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.LIST_MULTI;

        result.params = {
            displayName         : result.displayName?.trim(),
            listItems           : result.listItems,
            listItemsIncSeed    : result.listItemsIncSeed,
            scope               : result.scope
        };

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}/>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldItemsList form={this.form}/>
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}